import { render, staticRenderFns } from "./fieldPhone.vue?vue&type=template&id=5fbba3e6&scoped=true&"
import script from "./fieldPhone.vue?vue&type=script&lang=js&"
export * from "./fieldPhone.vue?vue&type=script&lang=js&"
import style0 from "./fieldPhone.vue?vue&type=style&index=0&id=5fbba3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbba3e6",
  null
  
)

export default component.exports